import { SiCplusplus } from 'react-icons/si'

export const CppTech = () => {
    return (
        <div>
        <SiCplusplus />
        <h4>C++</h4>
        </div>
    )
}